import get from 'lodash/get';
import { appRefreshed } from './containers/Authorization/actions';
import configureRedux from './configureRedux';

export default (callback) => {
  configureRedux({}, (store) => {
    store.dispatch(appRefreshed(get(store.getState(), 'current.viewer'))).then(() => callback(store));
  });
};
